/**
 * The text colour for something drawn ON a fill (1NOW-11135): white or near-black, whichever
 * has the higher WCAG contrast with it, so a tenant's button colour can be as pale as #F5EFE0
 * or as dark as #1C1917 and its label stays readable.
 *
 * Only a mid-tone grey (luminance 0.18 to 0.22) leaves both under 4.5:1, at worst 4.19:1. Black
 * clears the bar there, so it is used for those and only those.
 */
export const ON_DARK = "#FFFFFF";
export const ON_LIGHT = "#111827";
const BLACK = "#000000";
const AA = 4.5;

const channel = (c: number) => {
  const s = c / 255;
  return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
};

const luminance = (hex: string) => {
  const n = parseInt(hex.replace("#", ""), 16);
  return 0.2126 * channel((n >> 16) & 255) + 0.7152 * channel((n >> 8) & 255) + 0.0722 * channel(n & 255);
};

export const contrastRatio = (a: string, b: string) => {
  const la = luminance(a);
  const lb = luminance(b);
  return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
};

/** "#RRGGBB" in; ON_DARK on a dark fill, ON_LIGHT on a light one. */
export const onColor = (fill: string): string => {
  const best = contrastRatio(fill, ON_DARK) >= contrastRatio(fill, ON_LIGHT) ? ON_DARK : ON_LIGHT;
  return contrastRatio(fill, best) < AA && contrastRatio(fill, BLACK) >= AA ? BLACK : best;
};
